import { ThemeConfiguration } from '@roc/feature-types';
import { useContext } from 'react';
import { ThemeConfigurationContext } from './../context/themeConfigurationContext';

export function useThemeConfiguration(): (ThemeConfiguration | undefined) {
  return useContext(ThemeConfigurationContext);
}
